import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputGroup from 'react-bootstrap/InputGroup';
import Form from 'react-bootstrap/Form';
import { errorIcon } from '../../../assets/images';
import { maxLengthValidator } from '../../../utility/validate';
import { formatter } from '../../../utility';

const numberInputRegex = /^\d*\.?\d{0,2}$/;
class InputBase extends Component {
  //pass event object to parent handle change function
  handleChange = (event) => {
    const { value } = event.target;
    const { maxLength, type, handleChange } = this.props;

    if (type === 'date-picker') return;
    if (type === 'number' && !(numberInputRegex.test(value))) return;
    
    if (maxLength) {
      const valid = maxLengthValidator(String(event.target.value), maxLength);
      if (!valid) return;
    }

    handleChange(event, this.props);
  };

  renderStartAdornment = () => {
    const { startAdornment, disabled } = this.props;
    if (startAdornment) {
      return (
        <>
          <InputGroup.Prepend className="input-base-addon">
            <InputGroup.Text className={`input-base-text${disabled ? '-disabled' : ''}`}>{startAdornment}</InputGroup.Text>
          </InputGroup.Prepend>
        </>
      );
    }
  };

  renderEndAdornment = () => {
    const { endAdornment, onClick, disabled } = this.props;
    if (endAdornment) {
      return (
        <div className="input-base-append" onClick={onClick}>
          <InputGroup.Append className="input-base-addon">
            <InputGroup.Text className={`input-base-text${disabled ? '-disabled' : ''}`}>{endAdornment}</InputGroup.Text>
          </InputGroup.Append>
        </div>
      );
    }
  };

  renderComponentType = () => {
    const { name, type, value, disabled, maxLength, selectList, onClick, prependLabel, handleSelectChange } = this.props;

    switch (type) {
      case 'text':
      case 'number':
        return <Form.Control name={name} type='text' value={value} disabled={disabled} onChange={this.handleChange} maxLength={String(maxLength)} />;
      case 'date-picker':
        return (
          <Form.Control autoComplete="off" name={name} type='text' value={value} disabled={disabled} onChange={(date) => this.handleChange(date)} onClick={onClick} maxLength={String(maxLength)} />
        );
      case 'select':
        return (
          <>
            {prependLabel ? <span className="input-base-label-prepend">{prependLabel}</span> : null}
            <Form.Control className={`input-base-select`} value={value || 'default'} name={name} as="select" disabled={disabled} onChange={handleSelectChange}>
              <option style={{ display: 'none' }} disabled value={'default'}></option>
              {selectList.map((option, index) => {
                return (
                  <option key={index} value={option.value}>
                    {option.text}
                  </option>
                );
              })}
            </Form.Control>
          </>
        );
      default:
        return;
    }
  };

  renderPrintLabel = () => {
    const { value, type } = this.props;
    let printValue = '';
    if (type === 'text') printValue = String(value);
    else if (type === 'number') printValue = formatter.toAmountDisplay(value);
    else if (type === 'date-picker') printValue = formatter.toDateDisplay(value);
    else if (type === 'select' && ( value === '0' || value === '1' )) printValue = (value === '0' ? 'No' : 'Yes');

    return (
      <>
        <span className="input-base-print-value show-print">{printValue}</span>
      </>
    );
  } 

  render() {
    const { errors, label, topLabel, cssClass } = this.props;

    const renderTopLabel = () => topLabel ? <span className="input-base-top-label">{topLabel}</span> : null; 
    const renderLabel = () => label ? <span className="input-base-label" dangerouslySetInnerHTML={{ __html: label }}></span> : null;
    return (
      <div className={`input-base ${cssClass || ''}`}>
        <div className="input-base-wrapper">
          <div className={`hide-print input-base-wrapper-adornments${label ? '--default' : ''}`}>
            {renderTopLabel()}
            { this.renderStartAdornment() }
            { this.renderComponentType() }
            { this.renderEndAdornment() }
          </div>
          { renderLabel() }
          { this.renderPrintLabel() }
        </div>
        <label className="input-base-error">
          {errors ? <img className="input-base-error-icon" src={errorIcon} alt="" /> : null}
          {errors}
        </label>
      </div>
    );
  }
}

InputBase.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  handleChange: PropTypes.func,
  handleSelectChange: PropTypes.func,
  preprendLabel: PropTypes.string,
  cssClass: PropTypes.string,
  topLabel: PropTypes.string,
  label: PropTypes.string,
  errors: PropTypes.string,
  startAdornment: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  endAdornment: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  maxLength: PropTypes.number,
  selectList: PropTypes.array, //only used for type="select"
};

export default InputBase;
